webpackJsonp([263791100135453],{

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(47);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(39);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _fragments = __webpack_require__(46);
	
	var _mapper = __webpack_require__(38);
	
	var _Typography = __webpack_require__(20);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _Button = __webpack_require__(45);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Grid = __webpack_require__(25);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _styles = __webpack_require__(11);
	
	var _site = __webpack_require__(43);
	
	var _site2 = _interopRequireDefault(_site);
	
	var _gradient = __webpack_require__(83);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _metadata = __webpack_require__(42);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _banner = __webpack_require__(67);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _footer = __webpack_require__(41);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _inline = __webpack_require__(139);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutPage = function AboutPage(props) {
	  var classes = props.classes;
	
	  var metadata = (0, _mapper.mapMetaData)(props.data.about);
	  var about = (0, _mapper.mapAbout)(props.data.about);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_metadata2.default, { data: metadata }),
	    _react2.default.createElement(_banner2.default, {
	      uid: 'about',
	      title: about.title,
	      subtitle: about.subtitle,
	      background: about.image_bg
	    }),
	    _react2.default.createElement(Metrics, { about: about }),
	    _react2.default.createElement(_gatsbyImage2.default, { sizes: about.image.sizes, alt: about.image.alt }),
	    _react2.default.createElement(Story, { about: about }),
	    _react2.default.createElement(_inline2.default, { urls: about.video.urls, poster: about.video.poster }),
	    _react2.default.createElement(Links, { about: about }),
	    _react2.default.createElement(_footer2.default, { policies: props.data.policies.edges })
	  );
	};
	
	var Metrics = (0, _styles.withStyles)(_site2.default)(function (props) {
	  var classes = props.classes,
	      about = props.about;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'aboutA' },
	    _react2.default.createElement(
	      'div',
	      { className: classes.aboutMetrics },
	      _react2.default.createElement(
	        'div',
	        { className: classes.contents },
	        _react2.default.createElement(
	          'div',
	          { className: classes.centred },
	          _react2.default.createElement(
	            _Grid2.default,
	            { container: true, spacing: 40, className: classes.aboutMetricsTitle },
	            _react2.default.createElement(
	              _Grid2.default,
	              { item: true, className: classes.title },
	              _react2.default.createElement(
	                _Typography2.default,
	                { variant: 'display1' },
	                _react2.default.createElement(_gradient2.default, {
	                  text: about.metric_title.text,
	                  fromColor: '#8645B3',
	                  toColor: '#89DEF4',
	                  direction: 'left'
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Grid2.default,
	            {
	              container: true,
	              spacing: 0,
	              justify: 'center',
	              alignItems: 'center',
	              className: classes.aboutMetricsGrid
	            },
	            about.metrics.map(function (item) {
	              return _react2.default.createElement(Metric, { item: item, classes: classes });
	            })
	          )
	        )
	      )
	    )
	  );
	});
	
	var Metric = function Metric(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: props.classes.aboutMetric },
	    _react2.default.createElement(
	      _Grid2.default,
	      { item: true },
	      _react2.default.createElement(
	        _Typography2.default,
	        { variant: 'display2' },
	        props.item.value.text
	      )
	    ),
	    _react2.default.createElement(
	      _Grid2.default,
	      { item: true },
	      _react2.default.createElement(
	        _Typography2.default,
	        { variant: 'subheading' },
	        props.item.metric.text
	      )
	    )
	  );
	};
	
	var Story = (0, _styles.withStyles)(_site2.default)(function (props) {
	  var classes = props.classes,
	      about = props.about;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'servicesA' },
	    _react2.default.createElement(
	      'div',
	      { className: classes.aboutStory },
	      _react2.default.createElement(
	        'div',
	        { className: classes.contents },
	        _react2.default.createElement(
	          'div',
	          { className: classes.centred },
	          _react2.default.createElement(
	            _Grid2.default,
	            { container: true, spacing: 40 },
	            _react2.default.createElement(
	              _Grid2.default,
	              { item: true, className: classes.title },
	              _react2.default.createElement(
	                _Typography2.default,
	                { variant: 'display1' },
	                _react2.default.createElement(_gradient2.default, {
	                  text: about.heading.text,
	                  fromColor: '#8645B3',
	                  toColor: '#89DEF4',
	                  direction: 'left'
	                })
	              )
	            ),
	            _react2.default.createElement('div', {
	              dangerouslySetInnerHTML: {
	                __html: about.content && about.content.html
	              },
	              className: classes.aboutStoryText
	            })
	          )
	        )
	      )
	    )
	  );
	});
	
	var Links = (0, _styles.withStyles)(_site2.default)(function (props) {
	  var classes = props.classes,
	      about = props.about;
	
	  var LinkButton = function LinkButton(props, link) {
	    return _react2.default.createElement(_gatsbyLink2.default, _extends({ to: link }, props));
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: 'servicesA' },
	    _react2.default.createElement(
	      'div',
	      { className: classes.aboutLinks },
	      _react2.default.createElement(
	        'div',
	        { className: classes.contents },
	        _react2.default.createElement(
	          'div',
	          { className: classes.centred },
	          _react2.default.createElement(
	            _Grid2.default,
	            { container: true, spacing: 40 },
	            _react2.default.createElement(
	              _Grid2.default,
	              { item: true, className: classes.title },
	              _react2.default.createElement(
	                _Typography2.default,
	                { variant: 'display1' },
	                _react2.default.createElement(_gradient2.default, {
	                  text: about.links_title.text,
	                  fromColor: '#8645B3',
	                  toColor: '#89DEF4',
	                  direction: 'left'
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: classes.aboutLinkGroup },
	          about.links.map(function (item) {
	            return _react2.default.createElement(
	              _Grid2.default,
	              { item: true, className: classes.aboutLinkItem },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/' + item.uid },
	                _react2.default.createElement(
	                  _Button2.default,
	                  { variant: 'contained' },
	                  item.link.text
	                )
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	});
	
	exports.default = (0, _styles.withStyles)(_site2.default)(AboutPage);
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-8f79e1feef762a61fb79.js